// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const useIsApprovalRequired = () => {
    const requiredRolesString = useAppSelector(
        state => state.data.accounts.byId["current"]?.properties?.rolesThatRequireApproval,
    );
    const requiredRoles: string[] = requiredRolesString ? JSON.parse(requiredRolesString) : [];
    const isApprovalRequired = (role: string) => {
        return requiredRoles.includes(role);
    };
    return isApprovalRequired;
};

export default useIsApprovalRequired;
